import { t } from "@web-monorepo/i18n/macro";
import { getImageSrc } from "@web-monorepo/static-assets";
import { DDSBodyText, DDSIconButton } from "@web-monorepo/dds";
import { IconPause, IconPlay } from "@web-monorepo/dds-icons";
import styles from "./CountdownControls.module.css";

type CountdownControlsProps = {
  seconds: number;
  icon: "play" | "pause";
  toggle: VoidFunction;
  restart: VoidFunction;
  incrementTimer: VoidFunction;
};

export default function CountdownControls({ seconds, icon, toggle, restart, incrementTimer }: CountdownControlsProps) {
  return (
    <div className={styles.container}>
      {seconds > 0 ? (
        <button
          type="button"

          data-name="countdown_controls:restart"
          onClick={restart}
          aria-label={t`Restart timer`}
          className={styles.restartButton}
        >
          <img src={getImageSrc("toolkit/public/static/images/redo.png")} width={24} height={24} alt="" />
        </button>
      ) : (
        // Reserve the slot so the play/pause button stays horizontally
        // centered when the restart affordance is hidden at expiry.
        <span className={styles.restartSpacer} aria-hidden="true" />
      )}
      <div className={styles.playPauseWrap}>
        <DDSIconButton
          variant="primary"
          size="large"
          data-name="countdown_controls:play_paus_button"
          aria-label={icon === "play" ? t`Play timer` : t`Pause timer`}
          tooltip={{
            content: icon === "play" ? t`Play timer` : t`Pause timer`,
            dataName: "countdown_controls:play_paus_button:tooltip",
          }}
          onClick={toggle}
        >
          {icon === "play" ? <IconPlay /> : <IconPause />}
        </DDSIconButton>
      </div>
      <button
        type="button"
        data-name="countdown_controls:countdown_controls_plus_10"
        onClick={incrementTimer}
        className={styles.incrementButton}
      >
        <DDSBodyText>+10</DDSBodyText>
      </button>
    </div>
  );
}
